<template>
  <div class="-home-gallery-item column is-4">
    <figure
      class="image is-square has-cursor-pointer"
      @click="isImageModalActive = true"
    >
      <img :src="imagePath" :ref="imageRef" />
    </figure>
    <p
      class="has-margin-top-10 subtitle is-size-6 has-text-weight-bold has-text-grey"
    >
      {{ imageTitle }}
    </p>
    <div>
      <b-modal :active.sync="isImageModalActive">
        <figure class="image">
          <img :src="imagePath" />
        </figure>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "GalleryItem",
  data() {
    return {
      isImageModalActive: false
    };
  },
  props: {
    imagePath: String,
    imageTitle: String,
    imageRef: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
